<template>
  <div id="children">
    <div v-if="state==1">
      <el-tabs type="border-card" v-model="tab" @tab-click="handleClick">
        <el-tab-pane label="子账户列表" name="1">
          <el-table :data="tableData" style="width: 100%" v-if="!isEmpty">
            <el-table-column prop="mobile" label="登录账号"></el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="children_remark" label="备注名" align="center"></el-table-column>
            <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
            <el-table-column prop="identity" label="身份"></el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  slot="reference"
                  type="text"
                  @click="remark_children(scope.row.mobile)"
                >备注</el-button>
                <el-button slot="reference" type="text" @click="del(scope.row.mobile)">删除</el-button>
                <el-button type="text" @click="view(scope.row.mobile)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="t2 lv4Text">
            <img style="margin:0 auto" :src="serve + '/image/none/none_img6.jpg'" alt="">
          </div>
        </el-tab-pane>
        <el-tab-pane label="添加子账户" name="2" style="padding: 50px 230px;">
          <el-form label-position="right" label-width="80px">
            <el-form-item label="子账户：">
              <el-input v-model="form.children" placeholder="请输入子账户手机号(本网站账号)"></el-input>
            </el-form-item>
            <el-form-item label="备注名：">
              <el-input v-model="form.children_remark" placeholder="请输入子账户备注名称"></el-input>
            </el-form-item>
            <el-form-item label="验证码：">
              <el-input placeholder="请输入验证码" v-model="form.code">
                <el-button slot="append" @click="getSMS" :disabled="smsDis">{{text1}}</el-button>
              </el-input>
            </el-form-item>
          </el-form>
          <div align="center">
            <el-button type="primary" style="width:150px;margin-top:50px" @click="submit">提交</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待审核子账户" name="3" style="padding-top: 20px;padding-bottom:80px">
          <el-table
            :data="tablechild"
            :header-cell-style="{
                    'background' : 'rgba(245,250,249,1)'
                  }"
            border
            style="width: 100%"
          >
            <el-table-column prop="bind_mobile" label="账号" align="center"></el-table-column>
            <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
            <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
            <el-table-column prop="identity" label="身份" align="center"></el-table-column>
            <el-table-column prop="date" label="操作" align="center">
              <template slot-scope="scope">
                <span @click="submitChild(scope.row.mobile)" class="submitclass">确定</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="state==0" style="background-color:#fff;padding-bottom:250px;">
      <div style="width:500px;margin:0 auto;">
        <img
          :src="serve +'/image/none/noOpenHost.jpg'"
          style="width:500px;"
        />
      </div>
      <div class="lv3Text" align="center" style="font-size:18px;margin-top:50px">
        <div style="margin-bottom:5px;">您暂时没有权限使用子账户管理功能，请联系</div>
        <div>
          24小时电话
          <span class="lv0Text">133 1168 8691</span> 开通后即可使用
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      tablechild: [],
      smsDis: false,
      text1: '获取短信',
      state: null,
      tableData: null,
      visible2: false,
      isEmpty: null,
      total: null,
      page: 1,
      form: {},
      tab: '1',
      tm: null,
      showRemark: false,
      mobile: this.$cookies.get('user'),
      token: this.$cookies.get('token')
    }
  },
  activated() {
    this.$store.state.user_location = '子账户管理'
  },
  created() {
    this.initData()
    this.getChild()
  },
  methods: {
    alert_success(message) {
      this.$message({
        type: 'success',
        message: message,
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        type: 'error',
        message: message,
        offset: 200
      })
    },
    remark_children(children) {
      var that = this
      this.$prompt('请输入子账户备注名', '备注子账户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          var where = {
            mobile: that.mobile,
            token: that.token,
            children: children,
            name: value
          }
          this.axios
            .get(this.serve + '/personal/children_remark', { params: where })
            .then(res => {
              var data = res.data
              if (data.status == 'success') {
                this.alert_success('备注成功')
              } else {
                this.alert_error('备注失败请重新备注')
              }
              this.geting()
            })
        })

        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
            offset: 200
          })
        })
    },
    handleClick() {
      this.getChild()
    },
    submitChild(v) {
      this.axios
        .get(this.serve + '/personal/agree_children', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token'),
            children: v
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$message({
              type: 'success',
              message: res.data.msg,
              offset: 200
            })
            this.getChild()
            this.geting()
          } else if (res.data.status == 'error') {
            this.$message.error(res.data.msg)
          }
        })
    },
    getChild() {
      this.axios
        .get(this.serve + '/personal/apply_children_list', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token')
          }
        })
        .then(res => {
          this.tablechild = []
          if (res.data.status == 'success') {
            this.tablechild = res.data.data
          } else if (res.data.status == 'error') {
          }
        })
    },
    //
    submit() {
      this.axios
        .get(this.serve + '/personal/create_children', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token'),
            children: this.form.children,
            verify_code: this.form.code,
            children_remark: this.form.children_remark
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            clearInterval(this.tm)
            this.text1 = '获取短信'
            this.smsDis = false
            this.form = {}
            this.tab = '1'
            this.initData()
            this.$message({
              showClose: true,
              type: 'success',
              message: '子账户添加成功',
              offset: 200,
              duration: 3000
            })
          } else {
            clearInterval(this.tm)
            this.text1 = '获取短信'
            this.smsDis = false
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
              offset: 200,
              duration: 3000
            })
          }
        })
    },
    getSMS() {
      this.axios
        .get(this.serve +'/personal/send_add_children', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token'),
            phone: this.form.children
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$message({
              message: '验证码已发送',
              type: 'success',
              offset: 200
            })
            var t = 59
            this.smsDis = true
            this.text1 = '60秒后重新发送'
            var that = this
            that.tm = setInterval(() => {
              that.text1 = t + '秒后重新发送'
              t--
              if (t < 0) {
                clearInterval(that.tm)
                that.text1 = '获取短信'
                that.smsDis = false
              }
            }, 1000)
          } else {
            this.$message.error(res.data.msg)
          }
        })
    },
    time_out() {},
    view(user) {
      this.$router.push('/user/viewChild?user=' + user)
    },
    del(user) {
      this.$confirm('此操作将永久删除该账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios
            .get(this.serve +'/personal/del_children', {
              params: {
                mobile: this.$cookies.get('user'),
                token: this.$cookies.get('token'),
                c_mobile: user
              }
            })
            .then(res => {
              if (res.data.status == 'success') {
                this.$message('已删除')
                this.visible2 = false
                this.axios
                  .get(this.serve +'/personal/my_children', {
                    params: {
                      mobile: this.$cookies.get('user'),
                      token: this.$cookies.get('token'),
                      page: this.page
                    }
                  })
                  .then(res => {
                    if (res.data.data.total == 0) {
                      this.isEmpty = true
                    } else if (res.data.status == 'success') {
                      this.tableData = _.toArray(res.data.data.results)
                      this.isEmpty = false
                    }
                  })
              } else {
                this.$message.error(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
            offset: 200
          })
        })
    },
    initData() {
      this.axios
        .get(this.serve +'/personal/is_open_host', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token')
          }
        })
        .then(res => {
          if (res.data == 1) {
            this.state = 1
            this.geting()
          } else if (res.data == 0) {
            this.state = 0
          }
        })
    },
    geting() {
      this.axios
        .get(this.serve +'/personal/my_children', {
          params: {
            mobile: this.$cookies.get('user'),
            token: this.$cookies.get('token'),
            page: this.page
          }
        })
        .then(res => {
          if (res.data.data.total == 0) {
            this.isEmpty = true
          } else if (res.data.status == 'success') {
            this.tableData = _.toArray(res.data.data.results)
            this.isEmpty = false
          }
        })
    }
  }
}
</script>
<style lang="scss">
#children {
  .el-tabs__content {
    min-height: 600px;
  }
  .submitclass {
    cursor: pointer;
  }
  .submitclass:hover {
    color: #e2211c;
  }
  .t1 {
    padding: 10px 0;
  }
  .t2 {
    padding: 20px 0;
    text-align: center;
  }
}
</style>